import DOMPurify from "dompurify";

let hooksRegistered = false;

const registerSanitizerHooks = () => {
    if (hooksRegistered) {
        return;
    }

    hooksRegistered = true;

    DOMPurify.addHook("afterSanitizeAttributes", (node) => {
        if (node.tagName === "A" && node.hasAttribute("href")) {
            node.setAttribute("target", "_blank");
            node.setAttribute("rel", "noopener noreferrer");
        }
    });
};

registerSanitizerHooks();
